import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputErrorPipe } from './error-form.pipe';
import { TruncatePipe } from './truncate.pipe';
import { ReplacePipe } from './replace.pipe';
import { FormatCreateAndUpdateLabelPipe } from './format-date.pipe';
import { GetTransactionIdPipe } from './get-transaction-id.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    InputErrorPipe,
    TruncatePipe,
    ReplacePipe,
    GetTransactionIdPipe,
    FormatCreateAndUpdateLabelPipe
  ],
  exports: [InputErrorPipe, TruncatePipe, ReplacePipe, GetTransactionIdPipe, FormatCreateAndUpdateLabelPipe],
})
export class PipesModule {}
